import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const AttachmentModalOverlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: transparent;
  z-index: 2500;
  overscroll-behavior: none;
  touch-action: none;
`;

export const AttachmentModalContent = styled(motion.div)`
  position: fixed;
  bottom: calc(16px + 21px + 60px + 16px + env(safe-area-inset-bottom, 0px));
  width: 248px;
  padding: 12px;
  background: #1e1f22;
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.35);
  border-radius: 12px;
  outline: 1px #2b2d33 solid;
  outline-offset: -1px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
  z-index: 3001;
`;

export const AttachmentHeader = styled.span`
  color: #b7bdcb;
  font-size: 13px;
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
`;

export const BreakLine = styled.div`
  width: 100%;
  height: 0px;
  outline: 1px #2b2d33 solid;
  outline-offset: -0.5px;
`;

export const AttachmentItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 8px;
  color: #e9ecf5;
  font-size: 15px;
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover,
  &:active {
    background: #23252a;
  }
`;
